import { OrigemAtendimento, TipoAtendimentoHistoricoClinico } from 'graphql/types.generated'

import { HistoricoCabecalhoModel } from '../model/historicoModel'

export const historicoIsImpossibleToPrint = (historico: HistoricoCabecalhoModel) => {
  return (
    historico.origemAtendimento === OrigemAtendimento.CDS ||
    historico.origemAtendimento === OrigemAtendimento.AC ||
    historico.origemAtendimento === OrigemAtendimento.SISTEMA_TERCEIRO ||
    historico.tipoApresentacao === TipoAtendimentoHistoricoClinico.ESCUTA_INICIAL ||
    historico.tipoApresentacao === TipoAtendimentoHistoricoClinico.AVALIACAO_ELEGIBILIDADE
  )
}

export const pluralizeAndConcatValue = (value: number, text: string) => {
  return `${value} ${text}${value > 1 ? 's' : ''} `
}

export const hasSomeSubmodulesPlano = (form: HistoricoCabecalhoModel) =>
  form.hasAlergia ||
  form.hasPrescricaoMedicamento ||
  form.hasOrientacao ||
  form.hasAtestado ||
  form.hasLembrete ||
  form.hasSolicitacaoExame ||
  form.hasResultadoExame

export const mountDadosClinicosHeader = (historico: HistoricoCabecalhoModel) => {
  switch (historico.tipoApresentacao) {
    case TipoAtendimentoHistoricoClinico.CONSULTA:
    case TipoAtendimentoHistoricoClinico.PRE_NATAL:
    case TipoAtendimentoHistoricoClinico.PUERPERIO:
    case TipoAtendimentoHistoricoClinico.PUERICULTURA:
    case TipoAtendimentoHistoricoClinico.ATENDIMENTO_ODONTOLOGICO:
    case TipoAtendimentoHistoricoClinico.ATENDIMENTO_DOMICILIAR:
      if (historico.ciapNomeDescricao && historico.cidNomeDescricao) {
        return `${historico.ciapNomeDescricao} | ${historico.cidNomeDescricao}`
      }
      if (historico.ciapNomeDescricao) {
        return historico.ciapNomeDescricao
      }
      if (historico.cidNomeDescricao) {
        return historico.cidNomeDescricao
      }
      return null
    case TipoAtendimentoHistoricoClinico.VACINACAO:
      return historico.vacinaNomeSigla
    case TipoAtendimentoHistoricoClinico.ATENDIMENTO_PROCEDIMENTO:
      return historico.procedimentoNomeCodigo
    case TipoAtendimentoHistoricoClinico.AVALIACAO_ELEGIBILIDADE:
      if (historico.cid10SecundarioUmFaeNomeCodigo && historico.cid10SecundarioDoisFaeNomeCodigo) {
        return `${historico.cid10PrincipalFaeNomeCodigo} | ${historico.cid10SecundarioUmFaeNomeCodigo} | ${historico.cid10SecundarioDoisFaeNomeCodigo}`
      }
      if (historico.cid10SecundarioUmFaeNomeCodigo) {
        return `${historico.cid10PrincipalFaeNomeCodigo} | ${historico.cid10SecundarioUmFaeNomeCodigo}`
      }
      if (historico.cid10SecundarioDoisFaeNomeCodigo) {
        return `${historico.cid10PrincipalFaeNomeCodigo} | ${historico.cid10SecundarioDoisFaeNomeCodigo}`
      }
      return historico.cid10PrincipalFaeNomeCodigo
  }
}
